const NoProjects = () => {
    return (
        <div className='flex flex-col items-center justify-center h-full space-y-4'>
            <h1>No Projects</h1>
            <p>You are not currently linked to any projects</p>
        </div>
    )
}

export default NoProjects